import { render } from "./reportEatUrgeFood.vue?vue&type=template&id=22b97ee7"
import script from "./reportEatUrgeFood.vue?vue&type=script&lang=js"
export * from "./reportEatUrgeFood.vue?vue&type=script&lang=js"

import "./reportEatUrgeFood.vue?vue&type=style&index=0&id=22b97ee7&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__